import { useEffect } from 'react'

interface PageMeta {
  title: string
  description?: string
}

const DEFAULT_DESCRIPTION =
  'When the bravest people you know are the ones in trouble. A cinematic descent into maydays no one is talking about. And the fight to change what happens next.'

export function usePageMeta({ title, description }: PageMeta) {
  useEffect(() => {
    document.title = title

    const descEl = document.querySelector('meta[name="description"]')
    if (descEl) {
      descEl.setAttribute('content', description ?? DEFAULT_DESCRIPTION)
    }

    const ogTitle = document.querySelector('meta[property="og:title"]')
    if (ogTitle) ogTitle.setAttribute('content', title)

    const ogDesc = document.querySelector('meta[property="og:description"]')
    if (ogDesc) ogDesc.setAttribute('content', description ?? DEFAULT_DESCRIPTION)

    return () => {
      document.title = 'SPOKE | When the Bravest People You Know Are the Ones in Trouble'
      if (descEl) descEl.setAttribute('content', DEFAULT_DESCRIPTION)
    }
  }, [title, description])
}
